
export default {
    props: {
        type: String,
        collName: String,
        editItem: Object,
        fieldPath: String,
        readonly: Boolean,
        columnDefs: Array,
        noDataLabel: String,
    },

    data() {
        return {
            subItem: null,
            editSubItem: null,
        };
    },

    computed: {
        subFieldProps() {
            return {
                collName: this.collName,
                editItem: this.editSubItem,
                readonly: this.readonly,
                pathPrefix: this.type,
            };
        },
    },

    methods: {
        initEdit(subItem) {
            if (subItem) {
                this.subItem = subItem;
                this.editSubItem = _.cloneDeep(subItem);
            } else {
                this.editSubItem = $.getNu(this.collName, this.type);
            }
        },
        confirmEdit() {
            if (this.subItem) {
                $.replaceOne($.get(this.editItem, this.type), this.subItem, this.editSubItem);
            } else {
                $.get(this.editItem, this.type).push(this.editSubItem);
            }

            this.subItem = null;
            this.editSubItem = null;
        },
        cancelEdit() {
            this.subItem = null;
            this.editSubItem = null;
        },
    },
};
